import { Component, OnInit } from '@angular/core';

import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AskServerService } from '../ask-server.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  callType: string;

  constructor(
    private askServer: AskServerService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private iconRegistry: MatIconRegistry,
   
    private sanitizer: DomSanitizer
  ) {
    iconRegistry.addSvgIcon(
      'appel-serveur',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/appel-serveur.svg')
    );
    iconRegistry.addSvgIcon(
      'eau',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/eau.svg')
    );
    iconRegistry.addSvgIcon(
      'pain',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/pain.svg')
    );
    iconRegistry.addSvgIcon(
      'sel-poivre',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/sel-poivre.svg')
    );
    iconRegistry.addSvgIcon(
      'paiement',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/paiement.svg')
    );
  }

  id: string;
  showConfirmbar: boolean = false;

  firstshow: Observable<any>;

  ngOnInit(): void {
    // Get the ID that was passed with the URL
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.firstshow = this.askServer.confirmTableSend;
    
  }

  setCallType(callType) {
    this.callType = callType;
  }

  

  public appelServeur(idTable: string, callType: string) {
    localStorage.setItem('calltype', callType);
    this.router.navigate(['/confirm-table/' + idTable]);
    //this.firstshow.subscribe( data => this.router.navigate(['/confirm-table/'+idTable]));
    //this.askServer.appelServeur(idTable);
  }
}


